import { Link } from "react-router-dom";
import { Phone, Ghost, Music2 } from "lucide-react";
import { CONTACT } from "@/data/site";
import { Wordmark } from "@/components/site/Wordmark";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative z-10 border-t border-[var(--line)] bg-[#08090B]">
      <div className="container-x grid gap-10 py-14 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <Wordmark className="text-2xl" />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-[var(--muted)]">
            Detailing, valeting, window &amp; headlight tints, PPF, dashcam fitting, driveway &amp; gutter
            cleaning and fleet services. Quality work you can trust — at prices you'll love.
          </p>
        </div>

        <div>
          <h4 className="mb-4 text-xs font-semibold uppercase tracking-[0.24em] text-[var(--blue-bright)]">Explore</h4>
          <ul className="space-y-2.5 text-sm text-[var(--muted)]">
            <li><Link to="/#services" className="transition-colors hover:text-white">Core Services</Link></li>
            <li><Link to="/#specialist" className="transition-colors hover:text-white">Tints · PPF · Dash Cams</Link></li>
            <li><Link to="/services" className="transition-colors hover:text-white">Full Pricing</Link></li>
            <li><Link to="/#contact" className="transition-colors hover:text-white">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-xs font-semibold uppercase tracking-[0.24em] text-[var(--blue-bright)]">Get in touch</h4>
          <ul className="space-y-3 text-sm">
            <li><a href={CONTACT.phoneHref} className="flex items-center gap-2.5 text-white transition-colors hover:text-[var(--blue-bright)]"><Phone size={15} /> {CONTACT.phone}</a></li>
            <li><a href={CONTACT.snapchatHref} target="_blank" rel="noreferrer" className="flex items-center gap-2.5 text-[var(--muted)] transition-colors hover:text-white"><Ghost size={15} /> {CONTACT.snapchat}</a></li>
            <li><a href={CONTACT.tiktokHref} target="_blank" rel="noreferrer" className="flex items-center gap-2.5 text-[var(--muted)] transition-colors hover:text-white"><Music2 size={15} /> {CONTACT.tiktok}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[var(--line)]">
        <div className="container-x flex flex-col items-center justify-between gap-2 py-6 text-xs text-[var(--muted)] sm:flex-row">
          <span>© {new Date().getFullYear()} Fastlane Motors. All rights reserved.</span>
          <span className="uppercase tracking-[0.2em]">Clean · Protect · Impress</span>
        </div>
      </div>
    </footer>
  );
};
